import { Tooltip } from "@mui/material";
import { Button } from "primereact/button";
import { Column } from "primereact/column"
import { DataTable } from "primereact/datatable"
import { convertirFechaIsoAFormato } from "../../../../utilidades/formateos";
import { getTickets, updateEstatusTicket } from "../integracion";
import { useEffect } from "react";

const Tabla = ({ datos, setvisibleEditar, setColumnaSeleccionada, setDatos, filtros }) => {

    useEffect(() => {

    }, [datos])
    const verificar = async (rowData) => {
        const params = {
            id_ticket: rowData.ID_TR_GASOLINA,
            verificado: rowData.VERIFICADO,
        }
        await updateEstatusTicket(params)
        await getTickets(filtros, setDatos)
    }
    const renderPartidaCompra = (rowData) => {
        return (
            <>
                <div style={{ textAlign: "left", fontWeight: "bold" }}>
                    P- {rowData.PARTIDA}
                </div>
                <Tooltip title={rowData.NOMBRE_PROVEEDOR}>
                    <div style={{ textAlign: "left", color: "#DD9208", fontWeight: "bold" }}>
                        C- {rowData.ORDEN_DE_COMPRA ? rowData.ORDEN_DE_COMPRA : "Sin orden de compra"}
                    </div>
                </Tooltip>
            </>
        );
    };

    const renderViaCaptura = (value) => (
        <i className={`pi ${value ? "pi-check" : "pi-times"}`} />
    );

    const renderControles = (rowData) => (
        <div className="controles">
            <Button icon="pi pi-pencil" rounded text onClick={() => { setColumnaSeleccionada(rowData); setvisibleEditar(true) }} />
            {
                rowData.VERIFICADO ?
                    <>
                        <Tooltip title='Verificado'>
                            <Button icon="pi pi-check" severity="success" rounded text onClick={() => { verificar(rowData) }} />
                        </Tooltip>
                    </>
                    :
                    <>
                        <Tooltip title='Sin verificar'>
                            <Button icon="pi pi-times" severity="danger" rounded text onClick={() => { verificar(rowData) }} />
                        </Tooltip>
                    </>
            }
        </div>
    );
    const templateFecha = (rowData) => {
        return (
            convertirFechaIsoAFormato(rowData.FECHA)
        )
    }
    return (
        <>
            <div className="resumen-litros">
                Total Litros:{datos?.litros_totales ? datos.litros_totales : "0"} / Monto total{datos?.monto_total ? datos.monto_total : "0"}
            </div>

            <DataTable value={datos?.data} stripedRows
                responsiveLayout="scroll"
                scrollable
                scrollHeight="calc(100vh - 340px)"
                className="tabla-class-tickets">
                <Column field="ID_TR_GASOLINA" header="ID" body={(row) => row.ID_TR_GASOLINA ? row.ID_TR_GASOLINA : "Sin datos"} />

                <Column
                    header="Colaborador"
                    body={(row) => {
                        if (row.NOMBRE_CHOFER) return row.NOMBRE_CHOFER;
                        if (row.ADMINISTRATIVO) return row.ADMINISTRATIVO;
                        return "Sin datos";
                    }}
                />
                <Column field="NOMBRE_PROVEEDOR" header="Gasolinera" body={(row) => row.NOMBRE_PROVEEDOR ? row.NOMBRE_PROVEEDOR : "Sin datos"} />
                <Column field="UNIDAD" header="Unidad" body={(row) => row.UNIDAD ? row.UNIDAD : "Sin datos"} />
                <Column field="KILOMETRAJE" header="Kilometraje" body={(row) => row.KILOMETRAJE ? row.KILOMETRAJE : "Sin datos"} />
                <Column field="FOLIO" header="Folio" body={(row) => row.FOLIO ? row.FOLIO : "Sin datos"} />
                <Column field="FECHA" header="Fecha" body={templateFecha} />
                <Column field="COMBUSTIBLE" header="Combustible" body={(row) => row.COMBUSTIBLE ? row.COMBUSTIBLE : "Sin datos"} />
                <Column field="LITROS" header="Litros" body={(row) => row.LITROS ? row.LITROS : "Sin datos"} />
                <Column field="PRECIO" header="Precio" body={(row) => row.PRECIO ? row.PRECIO : "Sin datos"} />
                <Column field="MONTO" header="Monto" body={(row) => row.MONTO ? row.MONTO : "Sin datos"} />
                <Column field="PARTIDA" header="Partida (P)" body={(row) => row.partidaP ? "✔️" : "❌"} />
                <Column field="Partida (P) y Compra (C)" header="Compra (C)" body={renderPartidaCompra} />
                <Column field="Vía captura" header="Vía Captura" body={(row) => renderViaCaptura(row.VIA_CAPTURA)} />
                <Column header="Controles" body={renderControles} />
            </DataTable>
        </>
    )
}
export default Tabla 